import {AfterViewInit, Component, Inject, Input, OnInit} from '@angular/core';
import {FullUser} from '../../../model';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-user-portfolio-two-container',
  templateUrl: './user-portfolio-two-container.component.html',
  styleUrls: ['./user-portfolio-two-container.component.css']
})
export class UserPortfolioTwoContainerComponent implements OnInit, AfterViewInit {

  @Input() user: FullUser;
  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
  }

}
